export const appConstants = {
    CONTACT_WEB_HOOK_URL: 'https://outlook.office.com/webhook/7d6ba9d9-2fba-46ae-822f-f012584c1ccb@1fb639f3-44ab-4a04-803b-cfd2bb3b966d/IncomingWebhook/1005220bd3674708be6e159680e9e02e/e7595493-68c8-40e2-adca-576c840ea586'
}



// WEBPACK FOOTER //
// ./src/utils/constants.js